export class ImageOverlay {
  private root: HTMLElement
  private closeBtn: HTMLElement
  private isOpen = false

  private _onKey: (e: KeyboardEvent) => void
  private _onClose: () => void

  constructor() {
    // Root overlay
    this.root = document.createElement("div")
    this.root.className = "io"

    // Image container
    const wrap = document.createElement("div")
    wrap.className = "io_wrap"
    this.root.appendChild(wrap)

    // Close button
    this.closeBtn = document.createElement("button")
    this.closeBtn.className = "io_close"
    this.closeBtn.setAttribute("aria-label", "Close")
    this.closeBtn.innerHTML = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="1"/></svg><span>Close</span>`
    this.root.appendChild(this.closeBtn)

    document.body.appendChild(this.root)

    // Bind handlers
    this._onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") this.close()
    }
    this._onClose = () => this.close()

    this.closeBtn.addEventListener("click", this._onClose)

    // Click on backdrop closes
    wrap.addEventListener("click", (e: MouseEvent) => {
      if (e.target === wrap) this.close()
    })
  }

  init(): void {
    document.addEventListener("click", (e: MouseEvent) => {
      const target = e.target as HTMLElement

      // Find closest .g__l figure
      const figure = target.closest(".g__l")
      if (!figure) return

      // Skip if inside an <a> tag (listing pages use links)
      if (figure.closest("a")) return

      // Only open for images, not videos
      const img = figure.querySelector("img") as HTMLImageElement | null
      if (!img) return
      if (figure.querySelector("video")) return

      e.preventDefault()
      e.stopPropagation()
      this.open(img)
    })
  }

  open(source: HTMLImageElement): void {
    if (this.isOpen) return
    this.isOpen = true

    const img = document.createElement("img")
    img.src = source.src
    img.alt = source.alt || ""
    img.className = "io_image"

    const wrap = this.root.querySelector(".io_wrap")!
    wrap.innerHTML = ""
    wrap.appendChild(img)

    // Show overlay
    this.root.classList.add("is-open")

    // Hide nav
    const nav = document.getElementById("nav")
    nav?.classList.add("is-hidden")

    // Listeners
    window.addEventListener("keydown", this._onKey)
  }

  close(): void {
    if (!this.isOpen) return
    this.isOpen = false

    // Clear wrap
    const wrap = this.root.querySelector(".io_wrap")
    if (wrap) wrap.innerHTML = ""

    // Hide overlay
    this.root.classList.remove("is-open")

    // Show nav (unless on home page)
    const nav = document.getElementById("nav")
    const path = location.pathname
    if (path !== "/" && path !== "/index") {
      nav?.classList.remove("is-hidden")
    }

    // Remove listeners
    window.removeEventListener("keydown", this._onKey)
  }
}
